import { InjectionToken } from '@angular/core';

export const CHANNEL_NAME = new InjectionToken<string>('Channel Name');
export const MODEL_VERSION = new InjectionToken<string>('Model Version');
